import React, { useContext, useEffect } from "react";
import { MenuActive } from "./context/MenuActiveContext";

const TermsAndCondition = () => {
  const { setMunuActiv } = useContext(MenuActive);
  useEffect(() => setMunuActiv([true, "TermsAndCondition"]), [setMunuActiv]);

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms &amp; Conditions</h1>
        <p className="text-sm text-gray-500 border-b border-gray-200 pb-6 mb-6">Website: tikitaka.ae | Email: info@tikitaka.ae</p>
        <div className="text-gray-600 leading-7 space-y-4">
          <p>These Terms &amp; Conditions govern your use of the TikiTaka website, applications, marketplace, and related services.</p>
          <h2 className="text-xl font-semibold text-gray-900 pt-4">1. Acceptance of Terms</h2>
          <p>By accessing or using TikiTaka, you agree to these Terms. If you do not agree, please do not use the Services.</p>
          <h2 className="text-xl font-semibold text-gray-900 pt-4">2. Marketplace Use</h2>
          <p>TikiTaka provides a marketplace for new and used automotive parts. Users must provide accurate information and must not use the Services for unlawful or fraudulent activity.</p>
          <h2 className="text-xl font-semibold text-gray-900 pt-4">3. Accounts and Payments</h2>
          <p>You are responsible for keeping your account credentials secure. Product availability, pricing, delivery, returns, and payment terms may vary by seller and are subject to the applicable order details.</p>
          <h2 className="text-xl font-semibold text-gray-900 pt-4">4. Contact</h2>
          <p>For questions about these Terms, contact <a className="text-blue-600 hover:underline" href="mailto:info@tikitaka.ae">info@tikitaka.ae</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
